import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Reporting|Watched Candidates';

export type SPWatchedCadidatesLoc =
	| 'SPWatchedCadidatesPageTitle'
	| 'SPWatchedCadidatesSectionTitle'
	| 'SPWatchedCadidatesCmcIdLabel'
	| 'SPWatchedCadidatesLoginLabel'
	| 'SPWatchedCadidatesFirstNameLabel'
	| 'SPWatchedCadidatesLastNameLabel'
	| 'SPWatchedCadidatesLastExamDateLabel'
	| 'SPWatchedCadidatesWatchUntilLabel';

export const spWatchedCadidatesLocs: LocDefs<SPWatchedCadidatesLoc> = {
	SPWatchedCadidatesPageTitle: {
		defaultValue: 'Watched Candidates Report',
		description: 'Page title.',
		displayPath: `${dpRoot}|Page Title`,
		displayType: 'Title',
		portal: 'SP',
		legacyName: 'Core/Reporting.WatchedCandidates.Title.PageTitle',
		feature: HubFeature.Core,
	},
	SPWatchedCadidatesSectionTitle: {
		defaultValue: 'Watched Candidates',
		description: 'Section title.',
		displayPath: `${dpRoot}|Section Title`,
		displayType: 'Title',
		portal: 'SP',
		legacyName: 'Core/Reporting.WatchedCandidates.Title.SectionTitle',
		feature: HubFeature.Core,
	},
	SPWatchedCadidatesCmcIdLabel: {
		defaultValue: 'CMC ID',
		description: 'Column heading for CMC ID.',
		displayPath: `${dpRoot}|CMC ID`,
		displayType: 'Label',
		portal: 'SP',
		legacyName: 'Core/Reporting.WatchedCandidates.ColumnHeading.CmcId',
		feature: HubFeature.Core,
	},
	SPWatchedCadidatesLoginLabel: {
		defaultValue: 'Login',
		description: 'Column heading for login.',
		displayPath: `${dpRoot}|Login`,
		displayType: 'Label',
		portal: 'SP',
		legacyName: 'Core/Reporting.WatchedCandidates.ColumnHeading.Login',
		feature: HubFeature.Core,
	},
	SPWatchedCadidatesFirstNameLabel: {
		defaultValue: 'First Name',
		description: 'Column heading for first name.',
		displayPath: `${dpRoot}|First Name`,
		displayType: 'Label',
		portal: 'SP',
		legacyName: 'Core/Reporting.WatchedCandidates.ColumnHeading.FirstName',
		feature: HubFeature.Core,
	},
	SPWatchedCadidatesLastNameLabel: {
		defaultValue: 'Last Name',
		description: 'Column heading for last name.',
		displayPath: `${dpRoot}|Last Name`,
		displayType: 'Label',
		portal: 'SP',
		legacyName: 'Core/Reporting.WatchedCandidates.ColumnHeading.LastName',
		feature: HubFeature.Core,
	},
	SPWatchedCadidatesLastExamDateLabel: {
		defaultValue: 'Last Exam Activity',
		description: 'Column heading for last exam date',
		displayPath: `${dpRoot}|Last Exam Date`,
		displayType: 'Label',
		portal: 'SP',
		feature: HubFeature.Core,
	},
	SPWatchedCadidatesWatchUntilLabel: {
		defaultValue: 'Watch Until',
		description: 'Column heading for watch until.',
		displayPath: `${dpRoot}|Watch Until`,
		displayType: 'Label',
		portal: 'SP',
		legacyName: 'Core/Reporting.WatchedCandidates.ColumnHeading.WatchUntil',
		feature: HubFeature.Core,
	},
};

export const LOC_KEYS = MapLocKeys<SPWatchedCadidatesLoc>(spWatchedCadidatesLocs);
